'use es6';

import { combineReducers } from 'redux';
import authReducer from 'developer-docs-shared-components/modules/Auth/reducer';
import docReducer from 'developer-docs-shared-components/modules/Doc/reducers';
import endpointsReducer from './modules/EndpointsList/reducer';
import tryItReducer from 'developer-docs-shared-components/modules/TryIt/reducer';
export default combineReducers({
  auth: authReducer,
  doc: docReducer,
  endpoints: endpointsReducer,
  tryIt: tryItReducer
});